import { npcLogConstant } from 'src/redux/actions/constant';

const initialState = { response: null, isNpcActivityTypes: false, loading: false };

export const getNpcActivityTypesReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case npcLogConstant.GET_NPC_ACTIVITY_TYPES_SUCCESS:
      return { ...state, isNpcActivityTypes: true, response: action.payload?.data, loading: false };
    case npcLogConstant.GET_NPC_ACTIVITY_TYPES_FAILURE:
      // THIN-8233: keep `response` null on failure (never the raw axios error) so the entry form's
      // `response || []` then .map over activity types cannot crash the page behind the ErrorBoundary.
      return {
        ...state,
        isNpcActivityTypes: false,
        response: null,
        error: action.payload,
        loading: false,
      };
    case npcLogConstant.GET_NPC_ACTIVITY_TYPES_LOADER:
      return { ...state, loading: true };
    default:
      return state;
  }
};
